import ModalContainer from "./ModalContainer";
import { Form, Input, Select } from "antd";
import styles from "../../TransactionSetting.module.scss";
import { Dispatch, SetStateAction } from "react";
import { IParams } from "../../../../custom-hooks/useFetchNIPTransactions";
import { useFetchNIPTransactionStatus } from "../../../../custom-hooks/useFetchNIPTransactionStatus";
import { useFetchOutwardTransferProviders } from "../../../../custom-hooks/useFetchOutwardTransferProviders";

const { Option } = Select;

interface ITransactionsFilter {
  open: boolean;
  title: string;
  handleCancel: () => void;
  confirmBtnText?: string;
  cancelBtnTxt?: string;
  customActionBtnTxt?: string;
  query: IParams;
  setQuery: Dispatch<SetStateAction<IParams>>;
  setPageNumber: Dispatch<SetStateAction<number>>;
}

const TransactionsFilter = ({
  open,
  title,
  handleCancel,
  confirmBtnText,
  cancelBtnTxt,
  customActionBtnTxt,
  setQuery,
  setPageNumber,
}: ITransactionsFilter) => {
  const [form] = Form.useForm();

  const { data: transactionStatus, isLoading: isLoadingTransactionStatus } =
    useFetchNIPTransactionStatus();

  const { data: transferProviders, isLoading: isLoadingTransferProviders } =
    useFetchOutwardTransferProviders();

  const onFinish = (values: IParams) => {
    setQuery((prevQuery) => ({ ...prevQuery, ...values }));
    setPageNumber(1);

    handleCancel();
  };

  const handleOk = () => {
    form.submit();
  };

  const handleReset = () => {
    form.resetFields();
  };

  return (
    <ModalContainer
      open={open}
      title={title}
      handleOk={handleOk}
      handleReset={handleReset}
      handleCancel={handleCancel}
      confirmBtnText={confirmBtnText}
      cancelBtnTxt={cancelBtnTxt}
      customActionBtnTxt={customActionBtnTxt}
    >
      <Form
        form={form}
        layout="vertical"
        className={styles.filter_form}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item label="Start Date" name="startDate">
          <Input type="date" placeholder="00-00-0000" size="large" />
        </Form.Item>

        <Form.Item label="End Date" name="endDate">
          <Input type="date" placeholder="00-00-0000" size="large" />
        </Form.Item>

        <Form.Item label="Session ID" name="sessionId">
          <Input placeholder="Session ID" size="large" />
        </Form.Item>

        <Form.Item
          label={isLoadingTransactionStatus ? "Loading..." : "Status"}
          name="transactionStatus"
        >
          <Select
            placeholder="Select Status"
            size="large"
            disabled={isLoadingTransactionStatus}
          >
            {transactionStatus?.data?.map(
              (status: { id: number; name: string }) => (
                <Option value={status.id}>{status.name}</Option>
              ),
            )}
          </Select>
        </Form.Item>

        <Form.Item label="Provider" name="transferProvider">
          <Select
            placeholder={
              isLoadingTransferProviders
                ? "Fetching Providers..."
                : "Select Provider"
            }
            size="large"
            disabled={isLoadingTransferProviders}
          >
            {transferProviders?.data?.providers?.map(
              (provider: { id: number; name: string }) => (
                <Option value={provider.id}>{provider.name}</Option>
              ),
            )}
          </Select>
        </Form.Item>
      </Form>
    </ModalContainer>
  );
};

export default TransactionsFilter;
